<template>
  <div class="vendor-picker theme-group-2">
    <app-page-wrapper-grid>
      <h1 class="iw-visuallyhidden">Vendor Selection</h1>
      <div class="iw-layout-grid__row back-to-seat">
        <seat-page-link></seat-page-link>
      </div>
      <div class="iw-layout-grid__row vendor-picker__container">
        <h2 class="iw-visuallyhidden">Vendors</h2>
        <vendor-card
          v-for="(listItem, i) in collection"
          :key="`${listItem.id}_${i}`"
          class="iw-layout-grid__col--span-4"
          :vendor="listItem"
        >
        </vendor-card>
      </div>
    </app-page-wrapper-grid>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import VendorCard from "../../vendor/vendor-card/VendorCard";
import SeatPageLink from "./seat-page-link/SeatPageLink";
import { showToaster } from "@/utils";

export default {
  name: "VendorPicker",
  components: {
    SeatPageLink,
    VendorCard
  },
  props: {
    errorMessage: {}
  },
  computed: {
    ...mapGetters("vendor", {
      collection: "getVendorsList"
    })
  },
  mounted() {
    this.setSelectedPickup({ time: null, id: null });
    this.startClosedVendorsCheck();
    this.detectClosedVendors();
    if (this.errorMessage && Object.keys(this.errorMessage).length !== 0) {
      showToaster.call(this, {
        errorMessage: this.errorMessage
      });
    }
    this.setVendorAccessedDirectly(false);
  },
  updated() {
    if (this.collection.length === 1 && !this.errorMessage) {
      this.$router
        .push({
          name: "Vendor",
          params: { vendor: this.collection[0].id }
        })
        .catch((err) => {
          // push error
        });
    }
  },
  unmounted() {
    this.stopClosedVendorsCheck();
  },
  methods: {
    ...mapMutations({
      setSelectedPickup: "orderAhead/setSelectedPickup",
      setVendorAccessedDirectly: "venue/setVendorAccessedDirectly"
    }),
    ...mapActions("vendor", ["startClosedVendorsCheck", "stopClosedVendorsCheck", "detectClosedVendors"])
  }
};
</script>

<style scoped lang="scss">
.back-to-seat {
  padding-top: 24px;
  @include respond-to-desktop {
    min-height: 132px;
  }
  @include respond-to-laptop {
    min-height: 132px;
  }
}
.vendor-picker {
  &__container {
    @include respond-to-tablet {
      justify-items: center;
      grid-template-columns: repeat(auto-fit, minmax(60px, 2fr));
    }
    @include respond-to-mobile {
      justify-items: center;
    }
  }
}
</style>
